import { toast } from 'react-toastify';
import { compose, assoc } from 'ramda';

import { setRestrictions } from '../../Restrictions/store/actions';

import {
  setAutomationsErrors,
  clearAutomationsErrors
} from '../../Automations/store/actions';

import {
  setRestrictionsErrors,
  clearRestrictionsErrors
} from '../../Restrictions/store/actions';

import {
  setClientId,
  setAddress,
  setBasicInfo,
  setBasicInfoErrors,
  clearBasicInfoErrors,
  handlePostalCode,
  handleLoading
} from './actions';

import {
  fetchClient,
  createClient,
  updateClient,
  createSchedulingClient,
  updateSchedulingClient,
  requestUpdateRestrictions,
  requestUpdateAutomations
} from './services';

import { fetchAddress } from '../../../../../../helpers/externalServices';

export const loadClient = clientParams => dispatch => {
  dispatch(handleLoading(true));

  return fetchClient(clientParams)
    .then(({ data }) => {
      dispatch(setRestrictions(data));
      dispatch(setBasicInfo(data));
      return data;
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const upsertClient = (params, serviceOrderId) => dispatch => {
  let formatParams = compose(assoc('serviceOrderId', serviceOrderId));

  delete params['phone'];

  dispatch(handleLoading(true));

  if (!formatParams(params).clientId) {
    delete params['clientId'];

    return createClient(formatParams(params))
      .then(({ data }) => {
        toast.success('Cliente cadastrado com sucesso!');

        dispatch(clearBasicInfoErrors());
        dispatch(setBasicInfo(data));
        dispatch(setClientId(data.clientId));
        dispatch(handleLoading(false));

        return Promise.resolve();
      })
      .catch(error => {
        if(!error) {
          dispatch(clearBasicInfoErrors());
          return Promise.reject();
        }

        dispatch(setBasicInfoErrors(error));
        return Promise.reject();
      })
      .finally(() => dispatch(handleLoading(false)));
  } else {
    return updateClient(formatParams(params))
      .then(({ data }) => {
        toast.success('Cliente atualizado com sucesso!');

        dispatch(clearBasicInfoErrors());
        dispatch(setBasicInfo(data));
        dispatch(handleLoading(false));

        return Promise.resolve();
      })
      .catch(error => {
        if(!error) {
          dispatch(clearBasicInfoErrors());
          return Promise.reject();
        }

        dispatch(setBasicInfoErrors(error));
        return Promise.reject();
      })
      .finally(() => dispatch(handleLoading(false)));
  }
}

export const upsertSchedulingClient = (userId, establishmentId, clientId, params) => dispatch => {
  if(!clientId) {
    return createSchedulingClient(userId, establishmentId, params)
      .then(({ data }) => {
        dispatch(setBasicInfo(data));
        dispatch(setClientId(data.clientId));
        dispatch(handleLoading(false));

        return Promise.resolve(data);
      })
      .catch(() => {
        return Promise.reject();
      })
      .finally(() => dispatch(handleLoading(false)));
  }

  return updateSchedulingClient(userId, establishmentId, clientId, params)
    .then(({ data }) => {
      dispatch(setBasicInfo(data));
      dispatch(handleLoading(false));

      return Promise.resolve(data);
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const loadAddress = postalCode => dispatch => {
  dispatch(handlePostalCode({ disabled: true, status: true }));

  return fetchAddress(postalCode)
    .then(data => {
      if (data.erro) {
        dispatch(handlePostalCode({ disabled: true, status: false }));
        return toast.error('Não conseguimos encontrar o seu endereço.');
      }

      const { logradouro, bairro, localidade, uf } = data;

      dispatch(
        setAddress({
          street: logradouro,
          district: bairro,
          city: localidade,
          state: uf
        })
      );

      return dispatch(handlePostalCode({ disabled: false, status: false }));
    })
    .catch(() => toast.error('Problemas no servidor, tente novamente mais tarde.'))
    .finally(() => dispatch(handlePostalCode({ disabled: false, status: false })));
}

export const loadAddressWithoutPersist = postalCode => dispatch => {
  dispatch(handlePostalCode({ disabled: true, status: true }));

  return fetchAddress(postalCode)
    .then(data => {
      if (data.erro) {
        dispatch(handlePostalCode({ disabled: true, status: false }));
        toast.error('Não conseguimos encontrar o seu endereço.');
      }

      dispatch(handlePostalCode({ disabled: false, status: false }));

      return data;
    })
    .catch(() =>
      toast.error('Problemas no servidor, tente novamente mais tarde.')
    );
}

export const updateRestrictions = (userId, establishmentId, clientId, params) => dispatch => {
  dispatch(handleLoading(true));

  return requestUpdateRestrictions(userId, establishmentId, clientId, params)
    .then(() => {
      dispatch(clearRestrictionsErrors());
      toast.success('Cliente atualizado com sucesso!');
      return Promise.resolve();
    })
    .catch(error => {
      if(!error) {
        dispatch(clearRestrictionsErrors());
        toast.error('Houve um erro ao atualizar o cliente.');
        return Promise.reject();
      }

      dispatch(setRestrictionsErrors(error));

      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const updateAutomations = (userId, establishmentId, clientId, params) => dispatch => {
  dispatch(handleLoading(true));

  return requestUpdateAutomations(userId, establishmentId, clientId, params)
    .then(() => {
      dispatch(clearAutomationsErrors());
      toast.success('Cliente atualizado com sucesso!');
      return Promise.resolve();
    })
    .catch(error => {
      if(!error) {
        dispatch(clearAutomationsErrors());
        toast.error('Houve um erro ao atualizar o cliente.');
        return Promise.reject();
      }

      dispatch(setAutomationsErrors(error));

      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}